/* QIKIFY AUTO HIDE START */
var selectors = {
    Avenue: "#responsiveMenu",
    Blockshop: ".x-menu--level-1--container",
    Boundless: ".drawer-nav",
    Broadcast: ".main-menu",
    Brooklyn: "#AccessibleNav",
    Canopy: ".main-nav > ul",
    Debut: "#SiteNav",
    District: ".nav-bar .site-nav",
    Editions: ".navigation-desktop",
    Empire: ".site-navigation > .navmenu",
    Envy: "#main-navigation-wrapper .nav",
    Galleria: ".nav-standard-nav-area .nav",
    Icon: "#main-nav",
    Impulse: ".site-navigation",
    Minimal: "#AccessibleNav",
    Modular: ".nav-main > .menu",
    Motion: ".site-navigation",
    Narrative: ".navigation__container .navigation__links:first-child",
    Parallax: ".header__navigation",
    Prestige: ".Header__MainNav .HorizontalList",
    Simple: "#SiteNav > .list--nav",
    Showcase: ".nav-row > .tier-1 > ul",
    Split: ".link-list",
    Streamline: ".site-navigation",
    Supply: "#AccessibleNav",
    Testament: "#main-nav",
    Venue: ".primary-nav__items",
    Venture: "#SiteNav",
    Warehouse: ".nav-bar__linklist",
};

var theme = window.Shopify.theme.name;
var selector = Object.keys(selectors).find(function(s) { return new RegExp(s, "gi").test(theme); });

if (selector) {
    var style = "@media (min-width: 768px) { " + selectors[selector] + " { opacity: 0; }; }";
    var styleElement = document.createElement("style");

    styleElement.setAttribute("id", "qikify-auto-hide");
    styleElement.setAttribute("type", "text/css");
    styleElement.appendChild(document.createTextNode(style));
    document.getElementsByTagName("head")[0].appendChild(styleElement);
}
/* QIKIFY AUTO HIDE END */